import { useQuery } from "@tanstack/react-query";
import type { ConfigurationFetchInterface } from "@dealer-center/ddc-pages-configuration-interface";

const queryKeyBase = "ddc-pages-configuration";

export function useConfigurationAPIInterface({
  resource
}: ConfigurationFetchInterface) {
  return useQuery({
    queryKey: [queryKeyBase, resource],
    queryFn: () => getConfiguration(resource),
    retry: 1,
    staleTime: 1000 * 60 * 5 // 5 minutes
  });
}

const getConfiguration = async (resource?: string) => {
  const res = await fetch(
    `/landing/nxlambda/configuration${resource ? `/${resource}` : ""}`
  );
  if (res.ok) {
    return res.json();
  } else {
    throw new Error(res.statusText);
  }
};
